import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ORGANIZATION_REFERENCE_DATA_URL } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getOrganizationReferenceData = createAsyncThunk(
  'stop/getOrganizationReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(ORGANIZATION_REFERENCE_DATA_URL, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const organizationReferenceSlice = createSlice({
  name: 'stop/organizationReferenceData',
  initialState: null,
  reducers: {
    resetOrganizationReferenceData: () => null,
  },
  extraReducers: {
    [getOrganizationReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetOrganizationReferenceData } =
  organizationReferenceSlice.actions;

export default organizationReferenceSlice.reducer;
